import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';
import { PanoDurumService } from '@uygulamalar/hmi-pano/services/pano-durum.service';
import { BounceScrollDirective } from '@uygulamalar/hmi-pano/directives/bounce-scroll.directive';

@Component({
  selector: 'hmi-pano-personel-shell',
  standalone: true,
  imports: [CommonModule, RouterModule, BounceScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './personel.component.html',
  styleUrl: './personel.component.less',
})
export class HmiPanoPersonelShellComponent extends FikoYTKokBilesenComponent {
  constructor() { super(); }
  durum = inject(PanoDurumService);
}
